import {
  SurgeryInfo,
  usePatchSurgeryInfoMutation,
  useSurgeryInfoQuery
} from '@/modules/surgicalEvent';
import {
  useMutationForCurrentPatient,
  useQueryForCurrentPatient
} from '@/hooks';

export const useCurrentSurgeryInfo = () =>
  useQueryForCurrentPatient<SurgeryInfo>({
    useQuery: useSurgeryInfoQuery
  });

export const useCurrentPatchSurgeryInfo = () =>
  useMutationForCurrentPatient<SurgeryInfo>({
    useMutation: usePatchSurgeryInfoMutation
  });
